import {
  baseBuilder,
  butterflyBuilder,
  knightBuilder,
  vlavaBuilder,
} from './builders';

function TemplateDirector() {
  const builders = new Map();
  builders.set("base", baseBuilder());
  builders.set("butterfly", butterflyBuilder());
  builders.set("knight", knightBuilder());
  builders.set("vlava", vlavaBuilder());
  return {
    buildTemplate: (website) => builders.get(website.root.theme).buildTemplate(website)
  };
}

export default { getBuilder: TemplateDirector };



// WEBPACK FOOTER //
// ./src/store/generators/websiteTemplates/TemplateDirector.js